import * as stylex from "@stylexjs/stylex";
import { useEditorReorder } from "../use-editor-reorder";
import { EditorLinkRow } from "./editor-link-row";
import { NewLinkForm } from "./new-link-form";
import type {
  EditableLink,
  EditorLink,
  EditorLinkChange,
} from "./link-records";
import { linkStyles as styles } from "./links.stylex";

export type LinksEditorProps = Readonly<{
  mode: "edit";
  hasLockedLinks: boolean;
  links: readonly EditableLink[];
  loading: boolean;
  maxLinks: number;
  maxLabelLength: number;
  onUpdate(change: EditorLinkChange): void;
  onRemove(index: number): void;
  onReorder(move: Readonly<{ from: number; to: number }>): void;
  onAdd(link: EditorLink): string | null;
}>;

export function LinksEditor(props: LinksEditorProps) {
  const reorder = useEditorReorder({
    count: props.links.length,
    disabled: props.loading,
    onReorder: props.onReorder,
  });
  return (
    <div {...stylex.props(styles.stack)}>
      {props.hasLockedLinks ? (
        <p {...stylex.props(styles.label)}>Your links</p>
      ) : null}
      <ul {...stylex.props(styles.list)}>
        {props.links.map((link, index) => (
          <EditorLinkRow
            key={index}
            link={link}
            index={index}
            loading={props.loading}
            maxLabelLength={props.maxLabelLength}
            onUpdate={props.onUpdate}
            onRemove={props.onRemove}
            reorder={reorder}
          />
        ))}
      </ul>
      <NewLinkForm
        loading={props.loading}
        maxLabelLength={props.maxLabelLength}
        maxLinks={props.maxLinks}
        linkCount={props.links.length}
        onAdd={props.onAdd}
      />
    </div>
  );
}
